import { useCallback, useState } from "react";

const DEFAULT_MAX = 5;

/**
 * Row diamond toggles selection (max 5). Header diamond opens the dialog.
 */
export function useLcaRowComparison(maxSelected = DEFAULT_MAX) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const isSelected = useCallback(
    (id) => id != null && selectedIds.some((selected) => String(selected) === String(id)),
    [selectedIds]
  );

  const toggle = useCallback(
    (id) => {
      if (id == null) return;
      setSelectedIds((prev) => {
        const exists = prev.some((selected) => String(selected) === String(id));
        if (exists) {
          return prev.filter((selected) => String(selected) !== String(id));
        }
        if (prev.length >= maxSelected) return prev;
        return [...prev, id];
      });
    },
    [maxSelected]
  );

  const canSelectMore = selectedIds.length < maxSelected;

  const clear = useCallback(() => setSelectedIds([]), []);

  const openDialog = useCallback(() => {
    if (selectedIds.length > 0) setDialogOpen(true);
  }, [selectedIds.length]);

  return {
    selectedIds,
    setSelectedIds,
    isSelected,
    toggle,
    canSelectMore,
    maxSelected,
    dialogOpen,
    setDialogOpen,
    openDialog,
    clear,
  };
}
